<template>
    <page :busy="busy" :tabs="tabs" class="website-editor-page">
        <template v-if="currentWebsite">
            <b-container fluid class="h-100">
                <b-row class="website-editor-page-row">
                    <b-col md="5" lg="3" ref="left" class="p-0 h-100 scroll-container website-editor-page-form">
                        <b-row>
                            <b-col class="m-4">
                                <website-editor-form
                                    :website="currentWebsite"
                                    @preview-update="refreshFrame"
                                    @preview-update-css="refreshFrameCss"
                                    @reset="refreshFrame"
                                    @logo-upload="refreshFrame"
                                    @logo-delete="refreshFrame"
                                />
                            </b-col>
                        </b-row>
                    </b-col>
                    <b-col md="7" lg="9" class="website-editor-page-frame">
                        <iframe
                            ref="iframe"
                            :id="currentWebsiteFrameID"
                            :src="currentWebsite.preview_url"
                            class="mb-3"
                            width="100%"
                            frameborder="0"
                            marginheight="0"
                            marginwidth="0"
                            @load="iframeLoad"
                        ></iframe>
                    </b-col>
                </b-row>
            </b-container>
        </template>
    </page>
</template>

<script>
import { mapGetters } from 'vuex';
import API from '../../../api';
import { WEBSITE_CURRENT_ENDPOINT } from '../../../endpoints';
import Page from '../../generic/page/page.vue';
import WebsiteEditorForm from './website-editor-form.vue';

export default {
    name: 'WebsiteEditor',
    components: {
        Page,
        WebsiteEditorForm,
    },
    data() {
        return {
            busy: false,
            tabs: [
                {
                    title: 'Editor',
                    route: '/app/website/editor/',
                    active: true,
                },
            ],
        }
    },
    computed: {
        ...mapGetters('website', ['currentWebsite']),
        currentWebsiteFrameID() {
            if (this.currentWebsite) {
                return `website-iframe-${this.currentWebsite.id}`;
            }
            return 'website-iframe';
        },
        currentWebsiteFrameSrc() {
            if (this.currentWebsite) {
                const rand = Math.random();
                return `${this.currentWebsite.preview_url}&v=${rand}`;
            }
        }
    },
    mounted() {
        (async () => {
            this.busy = true;
            try {
                await this.fetchCurrentWebsite();
            } finally {
                this.busy = false;
            }
        })();
    },
    methods: {
        async fetchCurrentWebsite() {
            try {
                await this.$store.dispatch('website/fetchCurrentWebsite');
            } catch (err) {
                this.errorToast({ text: `Could not load a website.` });
            }
        },
        refreshFrame() {
            this.$refs.iframe.contentWindow.postMessage('refresh');
        },
        refreshFrameCss() {
            this.$refs.iframe.contentWindow.postMessage('refresh-css');
        },
        iframeLoad() {
            const iframe = document.getElementById(this.currentWebsiteFrameID);
            iframe.style.height = (this.$refs.left.offsetHeight || 3000) + 'px';
        },
    }
}
</script>

<style lang="scss" scoped>
@import '~bootstrap/scss/_functions.scss';
@import '~bootstrap/scss/_variables.scss';
@import '~bootstrap/scss/mixins/_breakpoints.scss';
.website-editor-page {
    display: flex;
    flex-direction: column;
    :deep(.lx-page-container) {
        overflow-y: hidden;
    }
    .scroll-container {
        overflow-y: auto;
        overflow-x: hidden;
    }
    .website-editor-page-row {
        height:100%;
    }
    .website-editor-page-form {
        background-color: #f7f7f7;
    }
    :deep(ul.nav) {
        margin-bottom: 0 !important;
        .router-link-active {
            background-color: #f7f7f7 !important;
            margin-bottom: 0 !important;
            border-color: #dee2e6 #dee2e6 transparent;
        }
    }
}

@include media-breakpoint-up(md) {
    .website-editor-page {
        .website-editor-page-frame {
            padding: 0 !important;
        }
    }
}

@include media-breakpoint-down(md) {
    .website-editor-page {
        :deep(.lx-page-container) {
            overflow: auto;

        }
        .scroll-container {
            overflow: unset;
        }
        .website-editor-page-row {
            height: auto;  
        }
    }
}
</style>
